module.exports = __webpack_public_path__ + "img/wind.0527e237.png";